import React from 'react';
import { Field } from 'formik';
import SearchWithDropdown from '@minecraft.search-with-dropdown';
import { withErrorMessage, setFieldValueAndTouched } from '@minecraft.utils';

const FormikSearchWithDropdown = ({ form, field, onChange, children, ...restProps }) => (
  <SearchWithDropdown
    value={field.value}
    onChange={(value) => setFieldValueAndTouched(field.name, value, form)}
    {...restProps}
  >
    {children}
  </SearchWithDropdown>
);

type Props = {
  name: string;
  children: React.ReactNode;
};

export default (props: Props) => (
  <Field name={props.name} {...props}>
    {(fieldProps) => withErrorMessage(FormikSearchWithDropdown)({ ...props, ...fieldProps })}
  </Field>
);
